import { Fragment, memo, ReactElement } from 'react';
import { Message } from '@JohnLewisPartnership/jl-design-system/components/message/Message';
import styles from './CreditBanner.module.scss';

export type Props = {
  creditType: string;
  bannerIndex: number;
  newTextEnabled: boolean;
};

export const CreditBanner = memo(
  ({ creditType, bannerIndex, newTextEnabled = false }: Props) => {
    const title: string =
      creditType === 'ifc'
        ? '*Interest free credit'
        : '*Interest bearing credit';

    const ifcBody: ReactElement = newTextEnabled ? (
      <Fragment>
        Credit subject to status. UK 18+. John Lewis plc is an appointed
        representative of John Lewis Finance Limited, who is a credit broker.
        Creation Consumer Finance Limited is the Lender. T&Cs apply.
      </Fragment>
    ) : (
      <Fragment>
        Credit subject to status. UK 18+. John Lewis PLC is a credit broker.
        Creation Consumer Finance Ltd is the lender.
      </Fragment>
    );

    const ibcBody: ReactElement = newTextEnabled ? (
      <Fragment>
        Representative example for 16.9% APR: If product price £1000.00 and your
        loan period is 3 years at 16.9% APR, you would pay 36 monthly repayments
        of £35.01, totalling £1,260.36. This includes £260.36 in interest.
        <br />
        Credit subject to status. UK 18+. John Lewis plc is an appointed
        representative of John Lewis Finance Limited, who is a credit broker.
        Creation Consumer Finance Limited is the Lender. T&Cs apply.
      </Fragment>
    ) : (
      <Fragment>
        Representative example for 16.9% APR: If product price £1000.00 and your
        loan period is 3 years at 16.9% APR, you would pay 36 monthly repayments
        of £35.01, totalling £1,260.36. This includes £260.36 in interest.
        <br />
        Credit subject to status. UK 18+. John Lewis PLC is a credit broker.
        Creation Consumer Finance Ltd is the lender.
      </Fragment>
    );

    const ifcIbcBody: ReactElement = newTextEnabled ? (
      <Fragment>
        Representative example for 16.9% APR: If product price £1000.00 and your
        loan period is 3 years at 16.9% APR, you would pay 36 monthly repayments
        of £35.01, totalling £1,260.36. This includes £260.36 in interest.
        <br />
        Interest free and other payment plans are available on selected
        products.
        <br />
        For 0% and 16.9% APR credit subject to status. UK 18+. John Lewis plc is
        an appointed representative of John Lewis Finance Limited, who is a
        credit broker. Creation Consumer Finance Limited is the Lender. T&Cs
        apply.
      </Fragment>
    ) : (
      <Fragment>
        Representative example for 16.9% APR: If product price £1000.00 and your
        loan period is 3 years at 16.9% APR, you would pay 36 monthly repayments
        of £35.01, totalling £1,260.36. This includes £260.36 in interest.
        <br />
        Interest free and other payment plans are available on selected
        products.
        <br />
        For 0% and 16.9% APR credit subject to status. UK 18+. John Lewis PLC is
        a credit broker. Creation Consumer Finance Ltd is the lender.
      </Fragment>
    );

    const body =
      creditType === 'ifc'
        ? ifcBody
        : creditType === 'ibc'
          ? ibcBody
          : ifcIbcBody;

    return (
      <aside
        aria-label={`Credit banner ${bannerIndex + 1}`}
        data-testid={`creditBanner-container-${bannerIndex + 1}`}
        data-test-type={creditType}
        className={styles.creditBanner}
      >
        <Message body={body} title={title} whiteBackground type="information" />
      </aside>
    );
  }
);

CreditBanner.displayName = 'CreditBanner';

export default CreditBanner;
